/* eslint-disable @typescript-eslint/no-explicit-any */
import {colorPalette, mainColor} from '@jobseeker/lotus/foundations';

import type {ThemeOptions} from '@mui/material/styles';

const theme: Partial<ThemeOptions> | any = {
  palette: {
    primary: {
      main: colorPalette.orange['A100'],
      contrastText: colorPalette.white['A50'],
      light: colorPalette.orange['A300'],
    },
    secondary: {
      main: colorPalette.black['A800'],
      light: colorPalette.black['A600'],
      contrastText: colorPalette.white['A50'],
    },
    text: {
      primary: colorPalette.black['A800'],
      secondary: colorPalette.black['A900'],
      tertiary: colorPalette.black['A100'],
      disabled: colorPalette.white['A300'],
    },
    background: {
      default: mainColor.white,
      secondary: colorPalette.orange['A100'],
    },
    info: {
      main: colorPalette.dustGreen['A400'],
    },
    error: {
      main: colorPalette.error['A700'],
      dark: colorPalette.error['A700'],
    },
    warning: {
      main: colorPalette.warning['A300'],
    },
    success: {
      main: colorPalette.success['A300'],
    },
    prompt: {
      main: colorPalette.prompt['A100'],
      dark: colorPalette.prompt['A200'],
      background: colorPalette.prompt['A300'],
    },
    gray: {
      light: colorPalette.white['A200'],
    },
    insights: colorPalette.orange.A100,
  },
  typography: {fontFamily: 'Nunito Sans'},
};

export default theme;
